<div class="dig-dialog dialog-gtm-snippet">
  <div class="dialog-top-bar">
    <h3 class="m-0">{{ 'gtm_snippet.title' | transloco }}</h3>
    <span (click)="close()" class="icon-close cta-btn" inlineSVG="/icons/icon-close.svg"></span>
  </div>

  <div class="dialog-content">
    @if (headSnippet) {
      <p class="snippet-intro">{{ 'gtm_snippet.intro' | transloco }}</p>
      <div class="snippet-block">
        <div class="snippet-block-header">
          <span class="snippet-block-label" [innerHTML]="'gtm_snippet.head_label' | transloco"></span>
          <button class="btn btn-dark-theme btn-grey cta-btn" type="button" (click)="copy('head')">
            <span class="icon mr-2" [inlineSVG]="'/icons/icon-copy.svg'"></span>
            <span>{{ (copied === 'head' ? 'gtm_snippet.copied' : 'gtm_snippet.copy') | transloco }}</span>
          </button>
        </div>
        <pre class="snippet-code">{{ headSnippet }}</pre>
      </div>
      <div class="snippet-block">
        <div class="snippet-block-header">
          <span class="snippet-block-label" [innerHTML]="'gtm_snippet.footer_label' | transloco"></span>
          <button class="btn btn-dark-theme btn-grey cta-btn" type="button" (click)="copy('footer')">
            <span class="icon mr-2" [inlineSVG]="'/icons/icon-copy.svg'"></span>
            <span>{{ (copied === 'footer' ? 'gtm_snippet.copied' : 'gtm_snippet.copy') | transloco }}</span>
          </button>
        </div>
        <pre class="snippet-code">{{ footerSnippet }}</pre>
      </div>
      <div class="snippet-note">
        <span class="note-icon" inlineSVG="/icons/icon-info-circle-v2.svg"></span>
        <span>{{ 'gtm_snippet.webflow_note' | transloco }}</span>
      </div>
    } @else {
      <div class="snippet-empty">
        <span class="note-icon" inlineSVG="/icons/icon-info-circle-v2.svg"></span>
        <span>{{ 'gtm_snippet.empty' | transloco }}</span>
      </div>
    }
  </div>

  <div class="dialog-footer justify-content-end">
    <button class="btn btn-dark-theme btn-grey cta-btn" type="button" (click)="close()">
      {{ 'global.close' | transloco }}
    </button>
  </div>
</div>
